import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useFoundingInstructor(userId: string | undefined) {
  return useQuery({
    queryKey: ['founding-instructor', userId],
    queryFn: async () => {
      const { data, error } = await (supabase.rpc as any)('is_founding_instructor', {
        p_user_id: userId!,
      });
      if (error) throw error;
      return data as boolean;
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
  });
}
